import { useParams } from 'react-router-dom';
import useBrandQuery from './useBrandQuery';

export const useBrand = () => {
    const { brandSlug = '' } = useParams<{
        brandSlug: string;
    }>();

    return useBrandSearchResultFilters(brandSlug);
};

export const useBrandSearchResultFilters = (brandSlug: string) => {
    const { brand, loading } = useBrandQuery({ brandSlug });
    const skip = !brand || loading;

    const filters = {
        skip,
        filters: [
            {
                name: 'PIM_ATT_ERP_MANUFACTURER',
                values: brand ? [brand.name] : [],
            },
        ],
        includeExcludedCategories: false,
    };
    const priceFilters = { brandSlug: brand?.slug ?? '', skip };

    return {
        brand,
        loading,
        filters,
        priceFilters,
        brandSlug,
    };
};
